<template>
	<a
		v-if="!hasAccessToEvents"
		class="c-header__krone-abo"
		:href="$arenaConfig.kroneOfferUrl"
		target="_blank"
		rel="noopener"
	>
		Abo
	</a>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name:     'SubscriptionBadge',
	computed: {
		...mapGetters({
			profile: 'user/profile',
		}),
		hasAccessToEvents() {
			return this.profile?.accessibleResources?.eventIds?.external?.length > 0 ?? false;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

/* stylelint-disable */
.c-header__krone-abo {
	display: flex;
	align-items: center;
	font-size: 14px;
	font-weight: 500;
	line-height: 1;
	color: var(--color-grey-900);
	text-decoration: none;
	background-color: var(--color-grey-050);
	padding: $sp3 $sp4;
	border-radius: 100px;
	height: 36px;
}

/* stylelint-enable */
</style>
